import { render, staticRenderFns } from "./modal_new_scholarship.vue?vue&type=template&id=1d9f53d7&scoped=true"
import script from "./modal_new_scholarship.vue?vue&type=script&lang=js"
export * from "./modal_new_scholarship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9f53d7",
  null
  
)

export default component.exports